import React, { useEffect, useMemo, useState } from 'react';
import './BannerSlider.css';

const BannerSlider = ({ slides = [], autoPlayMs = 5000, className = '' }) => {
    const safeSlides = useMemo(() => (Array.isArray(slides) ? slides : []), [slides]);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (!safeSlides.length || safeSlides.length === 1) {
            return undefined;
        }

        const timer = setInterval(() => {
            setActiveIndex((previous) => (previous + 1) % safeSlides.length);
        }, autoPlayMs);

        return () => clearInterval(timer);
    }, [safeSlides, autoPlayMs]);

    useEffect(() => {
        if (activeIndex > safeSlides.length - 1) {
            setActiveIndex(0);
        }
    }, [safeSlides.length, activeIndex]);

    if (!safeSlides.length) {
        return null;
    }

    const goToPrevious = () => {
        setActiveIndex((previous) => (previous - 1 + safeSlides.length) % safeSlides.length);
    };

    const goToNext = () => {
        setActiveIndex((previous) => (previous + 1) % safeSlides.length);
    };

    return (
        <div className={`custom-banner-slider ${className}`.trim()}>
            <div className='custom-banner-track'>
                {safeSlides.map((slide, index) => (
                    <div
                        key={`${slide.image}-${index}`}
                        className={`custom-banner-slide ${activeIndex === index ? 'active' : ''}`}
                        style={{ backgroundImage: `url('images/${slide.image}')` }}
                    >
                        <div className='custom-banner-overlay'>
                            <div className='custom-banner-title'>{slide.title}</div>
                            {slide.subtitle ? <div className='custom-banner-subtitle'>{slide.subtitle}</div> : null}
                        </div>
                    </div>
                ))}
            </div>

            {safeSlides.length > 1 ? (
                <>
                    <button type='button' className='custom-banner-arrow left' onClick={goToPrevious} aria-label='Previous slide'>
                        ‹
                    </button>
                    <button type='button' className='custom-banner-arrow right' onClick={goToNext} aria-label='Next slide'>
                        ›
                    </button>
                    <div className='custom-banner-dots'>
                        {safeSlides.map((slide, index) => (
                            <button
                                type='button'
                                key={`${slide.title}-${index}`}
                                className={`custom-banner-dot ${activeIndex === index ? 'active' : ''}`}
                                onClick={() => setActiveIndex(index)}
                                aria-label={`Go to slide ${index + 1}`}
                            ></button>
                        ))}
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default BannerSlider;
